'use client'
import React from 'react';
import './style.css';


const LegalPage = ({ title , legalcontent ,subtitle }) => {
    return (
        <div className="Legal-page-parent">
            <div className="Legal-page-title">
            <h2>{title}</h2>
            <div className="Legal-page-subtitle">
            <h3>{subtitle}</h3>
            </div>
            </div>
            <div className="Legal-page-content">
            <p>{legalcontent}</p>
            </div>
        </div>
    );
};

export default LegalPage;